import { useEffect, type ReactNode } from 'react';

import { useUIStore } from '@shared/stores/ui.store';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;

    if (theme === 'system') {
      const media = window.matchMedia('(prefers-color-scheme: dark)');
      root.classList.toggle('dark', media.matches);

      const handler = (e: MediaQueryListEvent) => {
        root.classList.toggle('dark', e.matches);
      };
      media.addEventListener('change', handler);
      return () => {
        media.removeEventListener('change', handler);
      };
    }

    root.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return <>{children}</>;
}
